import { useImmer } from "use-immer";
import { useEffect } from "react";

const Component = ({ config, onChange }) => {
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  return (
    <>
      <table className="config-table">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              History lookup min. <small>[minutes]</small>
            </td>
            <td>
              <input
                type="number"
                value={data.historyLookupMinutesMin}
                onChange={(e) =>
                  updateData((d) => {
                    d.historyLookupMinutesMin =
                      e.target.value < 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Score</td>
            <td>1</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default Component;
